import styled from 'styled-components'
import { grid, GridProps, height, HeightProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { LANDING_BASIC_HEADER_PADDING_INLINE } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns'].includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  GridProps & GapProps
>`
  display: grid;
  width: 100%;
  padding-inline: ${themeGet(`space.${LANDING_BASIC_HEADER_PADDING_INLINE}`)}px;

  ${grid}
  ${gap}
`

export const Card = styled.div<HeightProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 320px;

  > img {
    object-fit: cover;
    border-radius: 16px;
  }

  > img:last-of-type {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
  }

  ${height}
`
